/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyEventActive', DinghyEventActive);

    DinghyEventActive.$inject = ['$resource', 'DateUtils'];

    function DinghyEventActive ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-events/active';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for(var index = 0; index < data.length; index++) {
                            data[index].fromDate = new Date(DateUtils.convertLocalDateFromServer(data[index].fromDate));
                            data[index].untilDate = new Date(DateUtils.convertLocalDateFromServer(data[index].untilDate));
                        }
                    }
                    return data;
                }
            }
        });
    }
})();
